import axios from "axios";
import { toast } from "sonner";
import { getLang, t, tMsg } from "@/i18n";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
const TOKEN_KEY = "inm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (tk) => (tk ? localStorage.setItem(TOKEN_KEY, tk) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const tk = getToken();
  if (tk) cfg.headers.Authorization = `Bearer ${tk}`;
  cfg.headers["X-Lang"] = getLang();
  return cfg;
});
api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 402 && e.response.data?.code === "read_only") toast.error(tMsg(e.response.data.detail), { id: "read-only" });
  return Promise.reject(e);
});

// API error text in the UI language: known server messages are looked up in the catalog, anything else shows as sent.
export function errMsg(e, fallback) {
  const fb = fallback || t("Something went wrong. Please try again.");
  const d = e?.response?.data?.detail;
  if (!d) return fb;
  if (typeof d === "string") return tMsg(d);
  if (Array.isArray(d)) return d.map((x) => tMsg(x?.msg?.replace(/^Value error, /, "") || "")).filter(Boolean).join(" ");
  if (d.message) return tMsg(d.message);
  return fb;
}

export { mediaUrl, srcSet, srcWidths } from "./media";
